<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h3>Mis Informes</h3>
          <v-spacer />
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          />
        </v-card-title>
        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="reports"
          :pagination.sync="pagination"
          :search="search"
          rows-per-page-text="Documentos por pagina"
          :rows-per-page-items="[5,10,25,{ text: 'Todos', value: -1 }]"
        >
          <template v-slot:items="props">
            <td
              class="text-xs-left"
            >
              {{ props.item.fecha | parseDate }}
            </td>
            <td class="text-xs-left">
              {{ props.item.titulo }}
            </td>
            <td class="text-xs-left">
              <v-btn
                icon
                class="primary"
                small
                @click="openReportFilesModal(props.item)"
              >
                <v-icon>check</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ReportsTable',
  filters: {
    parseDate (val) {
      return moment(val).format('DD-MM-YYYY')
    }
  },
  props: {
    reports: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Fecha', value: 'fecha', class: 'small-width' },
        { text: 'Informe', value: 'titulo' },
        { text: '', value: null, sortable: false }
      ],
      search: '',
      pagination: { sortBy: 'fecha', descending: true }
    }
  },
  methods: {
    openReportFilesModal (props) {
      this.$emit('openReportFilesModal', props)
    }
  }
}
</script>

<style scoped>

</style>
